import { render, staticRenderFns } from "./Organizaciones.vue?vue&type=template&id=f1cce358&scoped=true"
import script from "./Organizaciones.vue?vue&type=script&lang=ts"
export * from "./Organizaciones.vue?vue&type=script&lang=ts"
import style0 from "./Organizaciones.vue?vue&type=style&index=0&id=f1cce358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cce358",
  null
  
)

export default component.exports